module.exports = __webpack_public_path__ + "static/media/down-arrow.31abbf76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/atoms/Select/down-arrow.svg
// module id = 598
// module chunks = 0